/**
 * @file   src\Pages\MySubscriptions.tsx
 * @brief  MySubscriptions page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Link, useState, useNavigate, useParams, useEffect,Modal, useLocation} from "../utils/thirdpartyComponents"
import { Badge, Button } from "react-bootstrap";
import Gobackicon from "../assets/images/left-arrow-small.svg";
import mysubscriptionicon from "../assets/images/my-subscriptions-img.svg"
import CWFooter from "src/components/CWFooter";
import "src/styles/inner-page-styles.scss";
import { pageURLs } from "src/utils/pageUrls";
import axios from "src/config/axiosConfig";
import { ProfileApi } from "src/utils/apiUrls";
import { MessageToaster } from "src/utils/toastUtil";
import { PurchasedSubscription } from "src/interfaces/subscriptionInterface";
import SmallLoader from '../components/SmallLoader';
import {splitTotal, getCurrencySymbol} from "../utils/helper";
import { BayApi } from "src/utils/apiUrls";
import { getFromLocalStorage } from "src/utils/helper";
import { BAY_AVAILABLE, BAY_BUSY, BAY_OUT_OF_SERVICE, BAY_QUEUE } from "src/utils/constants";
import { SubscriptionandwashpriceApi} from "../utils/apiUrls";
import { ISubscriptionandsinglewash,  ISingleWasharray , ISubscriptionarray} from '../interfaces/generalInterface';
import WashSelection from "src/components/WashSelection";
import { BuyType } from "src/utils/enums";
import { CommonMessages } from 'src/messages/validationMessages';
import moment from "moment";

const SelectWash = () => {
    const navigate = useNavigate();
    const params = useParams();
     // Instantiate MessageToaster
     const toaster = new MessageToaster();
     const location = useLocation();
     const queryParams = new URLSearchParams(location.search);
    // State to manage more and less button
    const [showAll, setShowAll] = useState(false);
    const [loading,setLoading] =  useState(false);
    const [showPaymentfailModal, setShowPaymentfailModal] = useState(false);
    const [showcancelConfirmation, setShowcancelConfirmation] = useState(false);
    const handleClosePaymentfailModal = () => setShowPaymentfailModal(false);
    const handleShowPaymentfailModal = () => setShowPaymentfailModal(true);
    const [singleWash, setSingleWash] = useState<ISingleWasharray[]>([]);
    const [purchasedsingleWash, setPurchasedSingleWash] = useState<PurchasedSubscription>();
    const [purchasedSubscription, setPurchasedSubscription] = useState<PurchasedSubscription[]>();
    const [showOrText,setShowOrText] =  useState(false);
    const [showSingleWashOrText,setShowSingleWashOrText] =  useState(false);
    const [purchasedSubscriptionExist,setpurchasedSubscriptionExist] =  useState(0);
    const [purchasedSingleWashExist,setpurchasedSingleWashExist] =  useState(0);
    const [showSinleWashCancelConfirmation, setSinleWashCancelConfirmation] = useState<boolean>(false);
    const [showSinleWashNewPurchaseConfirmation, setSinleWashNewPurchaseConfirmation] = useState<boolean>(false)
    const [SelectedSingeWashDetails, setSelectedSingeWashDetails] = useState<ISubscriptionarray>()
    const [purchsedFrom, setpurchsedFrom] = useState()
    const locationId_from_storage = localStorage.getItem('selectedLocation');
    const locationId = locationId_from_storage ? parseInt(locationId_from_storage, 10) : 0;
    const selectedBay = localStorage.getItem('selectedBay');
    const scanAction = (queryParams.get('scan') ==='true') ?  true  : false;
    const [disableProceedButton, setdisableProceedButton] = useState(false)
    const bayselectAction = (queryParams.get('bayselect') === 'true') ? true : false;
    const [activesinglewashid, setActivesinglewashid] = useState(0);
    const [activeBulkWash,setActiveBulkWash] = useState(false)
    

    // initial loading
    useEffect(() => {
        if(selectedBay === "" || selectedBay <= 0 || selectedBay === undefined || selectedBay === null) {
           navigate(`/${params.carwashname}`)
        } 
        washSelectionChecking()
       // fetchSingleWashData()
      }, []);

    
    const toggleShowAll = () => {
        setShowAll(!showAll);
    };

    const hasLocationBuyUps = async (): Promise<boolean> => {
        try {
            const locationId = localStorage.getItem('selectedLocation');
            const { data } = await axios.get(SubscriptionandwashpriceApi.BUYUP_LISTING, {
                params: {
                    locationId: locationId ? parseInt(locationId, 10) : 0,
                    bayId: selectedBay
                }
            });

            return data?.error === 0 && data?.data?.isBuyUpEnabled == true && Array.isArray(data?.data?.list) && data.data.list.length > 0;
        } catch (error) {
            return false;
        }
    };

    //Bay status checking
    const handleSubmit = async (washType = 2,washName:any) => {
      // API call to get bay status
      try {
        setdisableProceedButton(true)
        setLoading(true); // Show loader
        const param = selectedBay;
        const geo_location  = getFromLocalStorage('geolocation');
        const timezoneOffset = (new Date()).getTimezoneOffset();
        if((geo_location?.lat && geo_location?.long) || scanAction)
        {
                      // For subscriptions (washType === 2), redirect to Buy Ups page first
                        // Find the subscription data to pass to Buy Ups page
                        const subscriptionData = purchasedSubscription?.find(sub => sub.SubscriptionType === washType);
                        const locationHasBuyUps = await hasLocationBuyUps();
                        if(
                            washType != 1 &&
                            subscriptionData &&
                            (!subscriptionData.BuyUpDetails || subscriptionData.BuyUpDetails.length=== 0) &&
                            locationHasBuyUps
                        ) {
                          setLoading(false);
                          setdisableProceedButton(false);
                          navigate("/" + params.carwashname + "/" + pageURLs.buyups, { 
                            state: { 
                              subscriptionID: subscriptionData.UserSubscriptionID,
                              userSubscriptionId: subscriptionData.UserSubscriptionID,
                              washName: washName || subscriptionData.WashName,
                              price: subscriptionData.Price,
                              numberOfWashes: subscriptionData.NumberOfWashes,
                              subscriptionType: subscriptionData.SubscriptionType || washType,
                              bayId: selectedBay,
                              origin: 'SelectWash',
                              fromTab: 'subscription',
                            //   bayName: data.data.bayName,
                            //   bayNumber: data.data.bayNumber,
                            //   bayTypeID: data.data.bayTypeID,
                              scanAction: scanAction
                            } 
                          });
                        } 
                        else{
          const { data } = await axios.get(BayApi.GET_BAY_STATUS+param, {
            params: {
                lat: geo_location?.lat,
                lng: geo_location?.long,
                subType : washType ,//(1== single wash, 2 == subscription),
                scan: (scanAction) ? 1 : 0,
                offset: timezoneOffset,
            }
          });
          setLoading(false); // Hide loader
          setdisableProceedButton(false)
          if(data.error === 0)
          {
            let hostname = window.location.origin
            if(data.data.userNearToLocation === false && scanAction === false  && !(localStorage.getItem('freeSinglewash')=='true')  && !(localStorage.getItem('selectedLocation')=='249' && hostname == 'https://staging-web.carwashapp.com'))
            {
                toaster.toastError(data.message)
            }
           
            else if(data.data.bayOpen === false)
            {
                localStorage.removeItem('selectedBay')
                toaster.toastError(CommonMessages.bay_closed)
                navigate("/" + params.carwashname+ "/" + pageURLs.home );
            }
            else if(data.data.deviceStatus === false)
            {
              navigate("/" + params.carwashname + "/" + pageURLs.statusoutofservice);
            } 
            else if(data.data.subscription === false)
            {
              navigate(`/${params.carwashname}/${pageURLs.subscriptionandwashprice}?showSingleWash=true&scan=`+scanAction+"&washType="+washType,{ state: { bayId: localStorage.getItem('selectedBay') } });
              // navigate("/"+params.carwashname+"/"+pageURLs.subscriptionandwashprice, { state: { showSingleWash: true } });
            }
            else if(data.data.dailyWashLimitReached === true)
            {
                toaster.toastError(CommonMessages.exp_today_subscription);
                navigate("/" + params.carwashname+ "/" + pageURLs.home );

            }
            else if(data.data.washPackageError === true)
            {
                toaster.toastError(CommonMessages.washPackageError);
                navigate("/" + params.carwashname+ "/" + pageURLs.home );
            }
            else if(data.data.washCategoryError === true)
                {
                    toaster.toastError(CommonMessages.washCategoryError);
                    navigate("/" + params.carwashname+ "/" + pageURLs.home );
                }
            
            else
            {
              if(data.data.washRemaining<= 0 && data.data.isUnlimitedWash  == 0)
              {
                toaster.toastError(CommonMessages.no_wahses_remaining);
                navigate(`/${params.carwashname}/${pageURLs.subscriptionandwashprice}?showSingleWash=true&fromTab=singlewash&scan=`+scanAction+"&washType="+washType,{ state: { bayId: localStorage.getItem('selectedBay') }});
              } 
              
              else if(data.data.bayStatus === BAY_AVAILABLE && data.data.paymentStatus ===true)
              {
                navigate("/" + params.carwashname + "/" + pageURLs.statussuccess+"?washType="+washType, { state: { bayStatusSuccess: true,washName:washName ,bayName: data.data.bayName,bayNumber:data.data.bayNumber,bayTypeID:data.data.bayTypeID} });
              }
              else if(data.data.bayStatus === BAY_QUEUE)
              {
                navigate("/" + params.carwashname + "/" + pageURLs.scannerque+`?scan=`+scanAction+"&washType="+washType, { state: { selectedBayId: localStorage.getItem('selectedBay') ,washName:washName,bayName: data.data.bayName,bayNumber:data.data.bayNumber,bayTypeID:data.data.bayTypeID } });
              }
              else if(data.data.bayStatus === BAY_BUSY)
              {
                navigate("/" + params.carwashname + "/" + pageURLs.statusbusy+`?scan=`+scanAction+"&washType="+washType, { state: { selectedBayId: localStorage.getItem('selectedBay') ,washName:washName,bayName: data.data.bayName,bayNumber:data.data.bayNumber,bayTypeID:data.data.bayTypeID } });
              }
              else if(data.data.bayStatus === BAY_OUT_OF_SERVICE)
              {
                navigate("/" + params.carwashname + "/" + pageURLs.statusoutofservice);
              } 
           /*   else if(data.data.paymentStatus === false && data.data.deviceStatus === true && data.data.subscription === false)
              {

                handleShowPaymentfailModal();
              }*/
              else {
                navigate("/" + params.carwashname + "/" + pageURLs.statusoutofservice);
              }
            }

          }
          else
          {
            toaster.toastError(data.message);
            navigate("/" + params.carwashname+ "/" + pageURLs.home );

           
          }
        }
    }
        else{
          toaster.toastError(CommonMessages.no_loc_permission);
        }
      } catch (error: any) {
        throw new Error(error.response?.data?.message || error.message);
      }
    }
    //Fetch single wash data
    const fetchSingleWashData = async (singalewashExistFlag, subscriptionExistFlag, purchasedSingleWashId) => {
        const toaster = new MessageToaster();
        try {
        const requestSinglewashData: ISubscriptionandsinglewash = {
            typeID: 1,
            locationId: 0,
            bayId : Number(selectedBay)
        };
        const responseSingleWash = await axios.post(SubscriptionandwashpriceApi.Subscriptionandwashprice_FETCH,requestSinglewashData);
        setLoading(false); // Show loader
        if(responseSingleWash?.data?.error === 0)
        {
            const singleWashData = responseSingleWash?.data?.data?.subscriptionList.filter(wash => wash.subscriptionID!== purchasedSingleWashId);
            setSingleWash(singleWashData);
            checkOrTextStatus(singalewashExistFlag, subscriptionExistFlag,responseSingleWash?.data?.data?.subscriptionList)
            setActivesinglewashid(responseSingleWash.data.data.activeSingleWash);
                    const activeBulkWash = responseSingleWash?.data?.data?.activeBulkWash;

            if (activeBulkWash && Object.keys(activeBulkWash).length) {
                if(activeBulkWash?.NoOfWashRemaining > 0)
                {
                setActiveBulkWash(true)
                }
            }
                
        }
        else
        {
            toaster.toastError(responseSingleWash?.data?.message);
        }
        } catch (error: any) {
        throw new Error(error.response?.data?.message || error.message);
        }
    };

    const buynowClick = async(subscription: ISubscriptionarray,buyfrom : string) =>{
        if(purchasedSingleWashExist === 1) {
            setSelectedSingeWashDetails(subscription)
            setpurchsedFrom(buyfrom)
            setSinleWashNewPurchaseConfirmation(true)
        } else {
            onBuy(subscription,buyfrom);    
        }
    }

    const checkBayStatus = async (bayId: string, washName: string) => {
        try {
            if (!bayId) {
                navigate("/" + params.carwashname + "/" + pageURLs.home);
                return;
            }

            const geo_location = getFromLocalStorage('geolocation');
            const timezoneOffset = (new Date()).getTimezoneOffset();
            if ((geo_location?.lat && geo_location?.long) || scanAction === true) {
                const { data } = await axios.get(BayApi.GET_BAY_STATUS + bayId, {
                    params: {
                        lat: geo_location?.lat,
                        lng: geo_location?.long,
                        subType: 1,
                        scan: scanAction ? 1 : 0,
                        offset: timezoneOffset,
                    }
                });
                if (data.error === 0) {
                    const hostname = window.location.origin;
                    if (data.data.userNearToLocation === false && scanAction === false && !(localStorage.getItem('selectedLocation') == '249' && hostname == 'https://staging-web.carwashapp.com') && !(localStorage.getItem('freeSinglewash') == 'true')) {
                        localStorage.removeItem('selectedBay');
                        toaster.toastError(data.message);
                        navigate("/" + params.carwashname);
                    } else if (data.data.bayOpen === false) {
                        localStorage.removeItem('selectedBay');
                        toaster.toastError(CommonMessages.bay_closed);
                        navigate("/" + params.carwashname + "/" + pageURLs.home);
                    } else if (data.data.deviceStatus === false) {
                        navigate("/" + params.carwashname + "/" + pageURLs.statusoutofservice);
                    } else if (data.data.dailyWashLimitReached === true) {
                        toaster.toastError(CommonMessages.exp_today_subscription);
                        navigate("/" + params.carwashname + "/" + pageURLs.home);
                    } else if (data.data.washPackageError === true) {
                        toaster.toastError(CommonMessages.washPackageError);
                        navigate("/" + params.carwashname + "/" + pageURLs.home);
                    } else if (data.data.washCategoryError === true) {
                        toaster.toastError(CommonMessages.washCategoryError);
                        navigate("/" + params.carwashname + "/" + pageURLs.home);
                    } else if (data.data.bayStatus === BAY_AVAILABLE && data.data.paymentStatus === true) {
                        navigate("/" + params.carwashname + "/" + pageURLs.statussuccess + "?washType=1", { state: { bayStatusSuccess: true, washName: washName, bayName: data.data.bayName, bayNumber: data.data.bayNumber, bayTypeID: data.data.bayTypeID } });
                    } else if (data.data.bayStatus === BAY_QUEUE) {
                        navigate("/" + params.carwashname + "/" + pageURLs.scannerque + `?scan=` + scanAction + "&washType=1", { state: { selectedBayId: bayId, washName: washName, bayName: data.data.bayName, bayNumber: data.data.bayNumber, bayTypeID: data.data.bayTypeID } });
                    } else if (data.data.bayStatus === BAY_BUSY) {
                        navigate("/" + params.carwashname + "/" + pageURLs.statusbusy + `?scan=` + scanAction + "&washType=1", { state: { selectedBayId: bayId, washName: washName, bayName: data.data.bayName, bayNumber: data.data.bayNumber, bayTypeID: data.data.bayTypeID } });
                    } else {
                        navigate("/" + params.carwashname + "/" + pageURLs.statusoutofservice);
                    }
                } else {
                    toaster.toastError(data.message);
                    navigate("/" + params.carwashname + "/" + pageURLs.home);
                }
            } else {
                toaster.toastError(CommonMessages.no_loc_permission);
                navigate("/" + params.carwashname + "/" + pageURLs.home);
            }
        } catch (error: any) {
            toaster.toastError(error?.response?.data?.message || error?.message);
            navigate("/" + params.carwashname + "/" + pageURLs.home);
        }
    };

    //redirection to payment, or purchase immediately for manager free single wash
    const onBuy = async (subscription: ISubscriptionarray, buyfrom: string) => {
        const fromTab = buyfrom;
        const isManagerFreeSingleWash = subscription.subscriptionType === 1 && localStorage.getItem('freeSinglewash') === 'true';

        if (isManagerFreeSingleWash) {
            try {
                setLoading(true);
                const param = {
                    planId: subscription.subscriptionID,
                    promo_code: '',
                    locationId: Number(localStorage.getItem('selectedLocation')),
                    promo_code_type: 1,
                    payment_mode: 0,
                    removeParentLink: false,
                    buyupIds: []
                };
                const { data } = await axios.post(SubscriptionandwashpriceApi.PURCHASE_FREE_SINGLE_WASH, param);
                if (data?.error === 0) {
                    localStorage.setItem('subscriptionID', String(subscription.subscriptionID));
                    const bayId = selectedBay || location?.state?.bayId || '';
                    if (bayId) {
                        await checkBayStatus(String(bayId), subscription.washName);
                    } else {
                        toaster.toastSuccess(data?.message);
                        navigate("/" + params.carwashname + "/" + pageURLs.home);
                    }
                } else {
                    toaster.toastError(data?.message);
                }
            } catch (error: any) {
                toaster.toastError(error?.response?.data?.message || error?.message);
            } finally {
                setLoading(false);
            }
            return;
        }

        navigate("/"+params.carwashname+"/"+pageURLs.payment+"?scan="+scanAction+"&washType=1", { state: { origin: 'WashSelection_withsingle_wash', fromTab : fromTab, subscriptionID:subscription.subscriptionID,washName:subscription.washName,price:subscription.price,numberOfWashes:subscription.numberOfWashes,subscriptionType:subscription.subscriptionType,bayId: selectedBay ? selectedBay : "", isTrial :  subscription.isTrial, trialPeriod :  subscription.trialPeriod, trialAmount :  subscription.trialAmount} })
    };


    //Check subscription status
    const washSelectionChecking = async() => {
      const geo_location  = getFromLocalStorage('geolocation')
      if((geo_location?.lat && geo_location?.long) || scanAction)
      {
        const timezoneOffset = (new Date()).getTimezoneOffset();
        setLoading(true); // Show loader
        const { data } = await axios.get(BayApi.CHECK_WASHES_AVAILABLE, {
          params: {
              lat: (!scanAction) ? geo_location?.lat : 0,
              lng: (!scanAction) ? geo_location?.long : 0,
              bayId : selectedBay,
              offset: timezoneOffset
          }
        });
        setLoading(false); // Hide loader
        if(data.error === 0)
        {
           
            const subscriptions = [];
            const hasBulkWash = [];
            const subscriptionData = data?.data?.subData;
            let activeSubscriptionExist = 0;
            let activeBulkWashExist = 0;
            let singleWashPurchased = 0; 
            let singleWashSubscriptionId = 0
            setpurchasedSingleWashExist(data?.data?.subStatus?.hasSingleWash)
            for(let i = 0; i< subscriptionData.length; i++) {
                if(subscriptionData[i].SubscriptionType === 1) {
                    setPurchasedSingleWash(subscriptionData[i]);
                    singleWashSubscriptionId = subscriptionData[i].SubscriptionId;
                    singleWashPurchased = 1;
                } else {
                    // if(subscriptionData[i].SubscriptionType === 2) {
                    subscriptions.push(subscriptionData[i])
                    if(subscriptionData[i].NoOfWashRemaining > 0) {
                        activeSubscriptionExist = 1;
                    }
                }
                // else if(subscriptionData[i].SubscriptionType === 3) {
                //     hasBulkWash.push(subscriptionData[i])
                //     if(subscriptionData[i].NoOfWashRemaining > 0) {
                //         activeBulkWashExist = 1;
                //     }
                // }
            }
            if(activeSubscriptionExist) {
                setpurchasedSubscriptionExist(1);
            }
            console.log(subscriptions)
            setPurchasedSubscription(subscriptions)
            if(singleWashPurchased === 1) {
                checkOrTextStatus(data.data.subStatus.hasSingleWash, activeSubscriptionExist, singleWash)
                
            } 
            fetchSingleWashData(data.data.subStatus.hasSingleWash, activeSubscriptionExist, singleWashSubscriptionId)
          
        } else {
          toaster.toastError(data.message);
          navigate("/"+params.carwashname+"/"+pageURLs.home)
        } 
        
      } else{
        toaster.toastError(CommonMessages.no_loc_permission);
        navigate("/"+params.carwashname+"/"+pageURLs.home)
      }
    }

    function showPrice(Price : number){
        const { dollars, cents } = Price? splitTotal(Price) : {dollars:"",cents:""}
        const centswith2Digit = (cents && cents.length < 2) ? cents+'0' : cents;
        return <><div className="cw-card-value">{getCurrencySymbol()}{dollars}
            <span className="decimal-sec">.{cents ? centswith2Digit : "00"}</span>
        </div></>
    }

    const checkOrTextStatus = async(hasSingleWash : number, hasSubscription : number, singleWashData : any) => {
        if(hasSingleWash === 1 && hasSubscription === 1) {
            setShowOrText(true);
            setShowSingleWashOrText(false)
        } else {
            setShowOrText(false)
        }
        if(hasSubscription === 1 && singleWashData.length > 0 ) {
            setShowSingleWashOrText(true)
        } else {
            setShowSingleWashOrText(false)
        }
    }

    const cancelSingleWashCancellation = ()=>{
        setSinleWashCancelConfirmation(false)
    }

    const cancelSinglewashConfirm = ()=>{
        setSinleWashCancelConfirmation(true)
    }

    const cancelSingleWash = async()=>{
        try {
            setLoading(true); // Show loader
            const responseSingleWash = await axios.get(SubscriptionandwashpriceApi.CANCEL_SINGLE_WASH+'?bayId='+ selectedBay+'&bayType=0');
    
            if(responseSingleWash?.data?.error === 0)
            {
                setSinleWashCancelConfirmation(false)
                setpurchasedSingleWashExist(0)
                setPurchasedSingleWash({
                    userSubscriptionID: 0, 
                    WashName: '',
                    noOfWashRemaining: 0,
                    isCancelled: false,           
                    endDate: '',                
                    startDate: '' ,               
                    Price: 0,                   
                    SubscriptionDetails: '',     
                    noOfWash: 0,        
                })
                setLoading(false); // Show loader
                setpurchasedSubscriptionExist(0)
                fetchSingleWashData(0, purchasedSubscriptionExist, 0)
                toaster.toastSuccess(responseSingleWash?.data?.message)

            }
            else
            {
                setLoading(false); // Show loader
                setSinleWashCancelConfirmation(false)
                toaster.toastError(responseSingleWash?.data?.message);
            }
            } catch (error: any) {
                setLoading(false); // Show loader
                setSinleWashCancelConfirmation(false)
                throw new Error(error.response?.data?.message || error.message);
            }
    }
    //If already have single wash we will show confirmation popup
    const confirmSignleWashPurchase = async()=>{
        setSinleWashNewPurchaseConfirmation(false)
        onBuy(SelectedSingeWashDetails,purchsedFrom);   
    } 
    //Cancel single wash purchase
    const SingleWashPurchaseCancellation = ()=>{
        setSinleWashNewPurchaseConfirmation(false)
    }
    

    return (

        <div className="common-content-wrap pb-80">
            <div className="inner-content-wrap">
                <div className="common-header two-block-header">
                    <div className="pe-4 ps-4 pt-0 pb-0 h-100">
                        <div className="common-header-inner">
                            <Link to={"/" + params.carwashname+ "/" + pageURLs.home } className="back-link"><img src={Gobackicon} alt="Car Wash App" /></Link> Select Wash
                        </div>
                    </div>
                </div>
                
                    <div className="main-content-wrap pe-0 ps-0 pt-0">

                        {(purchasedsingleWash && purchasedSingleWashExist ) ? <div  className="my-subscription-wrap">
                            <div className="title">
                                <h4>Active Single Wash</h4>
                            </div>
                            <div className="cw-card ">
                                
                                <div className="cw-card-content">
                                    <div className="cw-card-leftcontent">
                                        <h6>{purchasedsingleWash?.WashName}</h6>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    showAll ? purchasedsingleWash?.SubscriptionDetails : (purchasedsingleWash?.SubscriptionDetails.length > 150 ? `${purchasedsingleWash?.SubscriptionDetails?.substring(0, 150)}...` : purchasedsingleWash?.SubscriptionDetails)
                                            }}
                                        ></div>

                                        {purchasedsingleWash?.SubscriptionDetails?.length > 150 && ( <>
                                            <div>
                                                <a onClick={toggleShowAll} className="more-less-btn">
                                                    {showAll ? <>
                                                        <span className="align-text-top">Less</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(1.061 9.615) rotate(-90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                                                    </> : <><span className="align-text-top">More</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(7.088 0.75) rotate(90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                                                    </>} 
                                                </a>
                                            </div>
                                        </> )}
                                        {purchasedsingleWash?.BuyUpDetails?.length ? (
                                            <div>
                                                <b>Customize your Wash:</b> {purchasedsingleWash.BuyUpDetails.map((buyup) => buyup.buyupname).join(", ")}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="cw-card-rightcontent">
                                    {showPrice(purchasedsingleWash?.Price)}
                                    </div>
                                </div>
                               
                                <div className="cw-card-btnwrap">
                                    <Button variant="primary" className="primary-btn" onClick={(e) => { handleSubmit(1,purchasedsingleWash?.WashName) }} disabled={disableProceedButton === true ? true : false}>Proceed</Button>
                                </div>
                                <div className="cw-card-btnwrap">
                                    <Button variant="primary" className="primary-btn" onClick={cancelSinglewashConfirm }>Cancel</Button>
                                </div>
                            </div>
                        </div> : '' }
                        {showOrText ? <div className="or text-center"><h6>OR</h6></div> : ''}
                        {purchasedSubscription?.length  ? <div  className="my-subscription-wrap">
                            <div className="title">
                                <h4>Active Subscription</h4>
                            </div>
                            {purchasedSubscription.map((mySubscriptions, index) => ( 
                                <div className={mySubscriptions?.NoOfWashRemaining > 0 || mySubscriptions?.IsUnlimitedWash==1 ? "cw-card" : "cw-card card-disable"}>
                                <div className="cw-card-content">
                                    <div className="cw-card-leftcontent">
                                        <h6>{mySubscriptions?.WashName}</h6>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: showAll
                                                ? mySubscriptions?.SubscriptionDetails
                                                : mySubscriptions?.SubscriptionDetails?.length > 150
                                                    ? mySubscriptions?.SubscriptionDetails.substring(0, 150) + "..."
                                                    : mySubscriptions?.SubscriptionDetails
                                            }}
                                            />
                                        {mySubscriptions?.BuyUpDetails?.length ? (
                                            <div>
                                                <b>Customize your Wash:</b> {mySubscriptions.BuyUpDetails.map((buyup) => buyup.buyupname).join(", ")}
                                            </div>
                                        ) : null}
                                        {/* {showAll ? mySubscriptions?.SubscriptionDetails : (mySubscriptions?.SubscriptionDetails?.length > 150 ? `${mySubscriptions?.SubscriptionDetails?.substring(0, 150)}...` : mySubscriptions?.SubscriptionDetails)} */}

                                        {mySubscriptions?.SubscriptionDetails?.length > 150 && ( <>
                                            <div>
                                                <a onClick={toggleShowAll} className="more-less-btn">
                                                    {showAll ? <>
                                                        <span className="align-text-top">Less</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(1.061 9.615) rotate(-90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                                                    </> : <><span className="align-text-top">More</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(7.088 0.75) rotate(90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                                                    </>} 
                                                </a>
                                            </div>
                                        </> )}
                                    </div>
                                    <div className="cw-card-rightcontent">
                                    {showPrice(mySubscriptions?.Price)}
                                       {mySubscriptions?.SubscriptionType!=3 ? 
                                        <div className="cw-card-smalltext">Per Month</div> :""}
                                    </div>
                                </div>
                                <div className="cw-card-validity d-grid">
                                    <div className="info-block text-center">
                                        <p>Actual Washes</p>
                                        <span>{mySubscriptions?.IsUnlimitedWash ? 'Unlimited' : mySubscriptions?.NumberOfWashes}</span>
                                    </div>
                                    <div className="info-block text-center">
                                        <p>Remaining Washes</p>
                                        {mySubscriptions?.IsUnlimitedWash ? 'Unlimited' : mySubscriptions?.NoOfWashRemaining > 0 ? <span>{mySubscriptions?.NoOfWashRemaining}</span> : <Badge bg="danger">No Wash Remaining</Badge>}
                                    </div>
                                     {mySubscriptions?.SubscriptionType!=3 ? <div className="info-block text-center">
                                   
                                        <div>
                                        <p>Valid Till</p>
                                        <span>{moment(new Date(mySubscriptions?.EndDate)).format("MM/DD/YYYY")}</span>
                                        </div>
                                       
                                        {mySubscriptions?.isCancelled ? <Badge bg="danger">Canceled</Badge> : ""}
                                    </div> :""}
                                   
                                </div>
                                <div className="cw-card-btnwrap">
                                    <Button variant="primary" className="primary-btn" onClick={(e) => { handleSubmit(mySubscriptions?.SubscriptionType,mySubscriptions?.WashName) }} disabled={(mySubscriptions?.NoOfWashRemaining <= 0 && mySubscriptions?.IsUnlimitedWash==0 || disableProceedButton === true) ? true : false}>Proceed</Button>
                                </div>
                            </div> )) }
                        </div> : ''}
                        {activeBulkWash == false && showSingleWashOrText ? <div className="or text-center"><h6>OR</h6></div> : ''}                               
                        {activeBulkWash == false && singleWash && singleWash.length > 0 ? <div  className="my-subscription-wrap">
                            <div className="title">
                                <h4>Single Wash</h4>
                                <p>Please select a wash below for your car wash.</p>
                            </div>
                           {activeBulkWash == false && singleWash && singleWash.length > 0 ? singleWash.map((wash, index) => (
                            <WashSelection
                            key={index}
                            SubscriptionID = {wash.subscriptionID} 
                            WashName={wash.washName} 
                            SubscriptionDetails={wash.subscriptionDetails} 
                            Price={wash.price} 
                            show_single_wash={true} 
                            buyType={BuyType.SINGLE_WASH} 
                            subscription={wash}
                            onBuynowClick = {(subscription: ISubscriptionarray)=>buynowClick(subscription,'singlewash')}
                            setShowcancelConfirmation = {(flag: boolean)=>setShowcancelConfirmation(flag)}
                            subscriptionType={wash.subscriptionType} 
                            scanAction={scanAction}
                            bayselectAction={bayselectAction}
                            activesinglewashid={activesinglewashid}
                            NumberOfWashes={wash.numberOfWashes}
                            ActiveBulkWash={activeBulkWash}
                            />
                            )) : ''}
                        </div> : ''}
                    </div>
            </div>

            <Modal
                show={showSinleWashCancelConfirmation}
                onHide={cancelSingleWashCancellation}
                centered
                className='notification-modal'
            >
                <Modal.Body className='text-center'>
                <h6>Are you sure you want to cancel this single wash?</h6>
                </Modal.Body>
                <Modal.Footer className='d-grid'>
                <Button variant="light" className="m-0" onClick={cancelSingleWashCancellation}>No</Button>
                <Button variant="primary" className='primary-btn btn-main m-0' onClick={cancelSingleWash}>Yes</Button>
                </Modal.Footer>
            </Modal>


            <Modal
                show={showSinleWashNewPurchaseConfirmation}
                onHide={SingleWashPurchaseCancellation}
                centered
                className='notification-modal'
            >
                <Modal.Body className='text-center'>
                <h6>You've already initiated a single wash. If you purchase this wash, your previously selected single wash will be canceled. Do you want to continue?</h6>
                </Modal.Body>
                <Modal.Footer className='d-grid'>
                <Button variant="light" className="m-0" onClick={SingleWashPurchaseCancellation}>No</Button>
                <Button variant="primary" className='primary-btn btn-main m-0' onClick={confirmSignleWashPurchase}>Yes</Button>
                </Modal.Footer>
            </Modal>
            <CWFooter activeLink="Home"/>
            {loading && <SmallLoader />}

        </div>
    )
}

export default SelectWash;
